//
//
//
//
import SelectField from "./_select";
export default {
  components: {
    // Need to start with `fields-` to enable jsonlogic in `styles.js#_linkFieldModels`
    "fields-genericSelect": SelectField
  },
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  computed: {
    defaultValue: function defaultValue() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
  }
};